import React from "react";

export default function VoucherFooterActions({
  onSave,
  onCancel,
  onDelete,
  canSave,
  saveDisabledReason,
  isSaving,
  isDeleting = false,
  isModifyMode = false,
  hasLoadedVoucher = false,
}) {
  return (
    <div className="vch_footer_actions_bar">
      <button
        type="button"
        className="vch_btn_cancel"
        onClick={onCancel}
        disabled={isSaving || isDeleting}
      >
        {isModifyMode ? "Reset" : "Cancel"}
      </button>

      <div className="vch_footer_right_actions">
        {/* Delete Voucher button: only in modify mode when a voucher is loaded, placed just before update */}
        {isModifyMode && hasLoadedVoucher && (
          <button
            type="button"
            className="vch_btn_delete_voucher"
            onClick={onDelete}
            disabled={isSaving || isDeleting}
            title="Delete this Voucher permanently"
          >
            {isDeleting ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i> Deleting...
              </>
            ) : (
              <>
                <i className="fa-regular fa-trash-can"></i> Delete
              </>
            )}
          </button>
        )}

        <div
          className="vch_save_btn_wrapper"
          title={
            !canSave
              ? saveDisabledReason
              : isModifyMode
              ? "Update Voucher Entry"
              : "Save Voucher Entry"
          }
        >
          <button
            type="button"
            className={`vch_btn_save ${!canSave ? "vch_btn_save_disabled" : ""} ${
              isModifyMode ? "vch_btn_update_mode" : ""
            }`}
            onClick={onSave}
            disabled={isSaving || isDeleting || !canSave}
          >
            {isSaving ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                {isModifyMode ? "Updating..." : "Saving..."}
              </>
            ) : (
              <>
                <i
                  className={
                    isModifyMode
                      ? "fa-solid fa-pen-to-square"
                      : "fa-regular fa-floppy-disk"
                  }
                ></i>{" "}
                {isModifyMode ? "Update Voucher" : "Save"}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
